<template>
  <div class="weui-cells weui-cells_form">
    <h3 class="page__title">链点提现</h3>    
    <h4 class="title">链点（1滴 = ￥0.01）</h4>
    
    <div class="weui-cell weui-cell_active weui-cell_vcode">
        <div class="weui-cell__hd">
            <label class="weui-label">链点余额</label>
        </div>
        <div class="weui-cell__bd weui-cell__bd-WU">
            <input class="weui-input" style="text-align:center" type="text" placeholder="" :value="balanceDataLD.points" />
        </div>
    </div>   
    <div class="weui-cell weui-cell_active weui-cell_vcode">
        <div class="weui-cell__hd">
            <label class="weui-label">提现数量</label>
        </div>
        <div class="weui-cell__bd weui-cell__bd-WU">
            <input class="weui-input" style="text-align:center" type="number" :max="balanceDataLD.points" placeholder="输入计划提现的链点数量" v-model="depositAmount" />
        </div>
    </div>
    <div v-if="applyComplete == false"><br/>
      <p v-if="depositAmount > 0">将为商户号【{{partnerid}}】提现,<br/>
        申请提现后，<span color="red">{{depositAmount}}</span>链点将立即扣除，</br>
        提现成功后，设定的银行卡将收到人民币￥<span color="red">{{fenToCNY(depositAmount)}}</span></p>
    </div>
    <div v-else><br/>
      <p v-if="depositAmount > 0">已为商户号【{{partnerid}}】提现,<br/>
        <span color="red">{{depositAmount}}</span>链点已经扣除，</br>
        提现成功后，设定的银行卡将收到人民币￥<span color="red">{{fenToCNY(depositAmount)}}</span></p>
    </div>
    <div class="weui-cell weui-cell_active weui-cell_vcode" v-if="applyComplete == false">
        <div class="weui-cell__hd">
        </div>
        <div class="weui-cell__bd">
          <a @click="letsDeposit" class="weui-btn weui-btn_primary">提现</a>
        </div>
    </div> 
    <div class="weui-cell weui-cell_active weui-cell_vcode" v-else>
      <div class="weui-cell__hd">
        </div>
        <div class="weui-cell__bd">
          <a @click="toDir('asset_mgr')" class="weui-btn weui-btn_primary">返回</a>
        </div>
    </div>
    <div v-if="(recordsWithDraw != null) && (recordsWithDraw.length > 0)">
     <hr/>
      <table class="table table-striped " style="font-size: small;" >
            <thead>
               <td>申请时间</td>
               <td>链点数量</td>
               <td>提现状态</td>
            </thead>
            <tbody>
              <tr v-for="rcd in recordsWithDraw" :key="rcd.id" >
                                       
                <td>{{ rcd.createTime }}</td>
                <td>{{ rcd.withdrawAmount }}</td>
                <td>{{ getRState(rcd.withdrawState) }}</td>  
              </tr>
            </tbody>
            <tfoot>

            </tfoot>
          </table>  
    </div>
    <!--   
    <div>
      {{JSON.stringify(rspData)}}
    </div>-->
  </div>        
</template>

<style>
.a_hot_touch{color:blue;font-style:italic;text-decoration:underline;}
</style>

<script>

import axios from "axios"
import JQ from 'jquery'
import wx from 'jweixin-1.6.0';
import {getPoints,getWithDrawRecords} from '../graphql/api'

export default {
data () {
  return {
    ing:true,
    partnerid:"",
    depositAmount:0,
    applyComplete:false,
    balanceDataLD:{points:0},
    recordsWithDraw:null
  }
},
mounted() {
     console.log( this.partnerid,sessionStorage.getItem("partnerid"))
     this.partnerid = sessionStorage.getItem("partnerid")
     console.log( this.partnerid,sessionStorage.getItem("partnerid"))

     this.getMyPoints();

     this.getMyWithDrawRecord();
},
methods: {      
  getMyPoints(){

    let that = this
    let paras = {};

    paras.pid = this.partnerid;
    paras.bd = this.dateStr + " 00:00:00";
    paras.ed = this.dateEndStr + " 23:59:59";
    paras.ls = [1,2];
    paras.lt = [1,2,3,4,8];
    paras.ld = [0,1];

    getPoints(paras)
    // findAllWeChatAccDailyStatement(that.partnerid,{bd:"2022-12-01",ed:"2022-12-05 23:59:59",ls:[1,2],lt:[1,2,3,4]})
    .catch(err=>{
      console.log(err)
    })
    .then(res1=>{
     // alert(1)
      console.info('获取数据=》'+JSON.stringify(res1.data))
      //alert(JSON.stringify(res1.data))
      that.balanceDataLD = res1.data.findPartnerPointsInfo.points;

    })
  },
  getMyWithDrawRecord(){
    let that = this
    let paras = {};

    paras.acc = this.partnerid;

    getWithDrawRecords(paras)
    // findAllWeChatAccDailyStatement(that.partnerid,{bd:"2022-12-01",ed:"2022-12-05 23:59:59",ls:[1,2],lt:[1,2,3,4]})
    .catch(err=>{
      console.log(err)
    })
    .then(res1=>{
     // alert(1)
      console.info('获取数据=》'+JSON.stringify(res1.data))
      //alert(JSON.stringify(res1.data))
      that.recordsWithDraw = res1.data.findAllWithdraw

    })
  },
  getRState(istate){if(istate == 1) return "成功"; return "处理中"},
  fenToCNY(fen){
    let prefix = "";
    let res= ""
    let intv = parseInt(fen)

    if(intv < 0) {
      intv = Math.abs(intv); 
      prefix = "-";
    }

    if(intv <= 9){
      res = "0.0"+ ( intv).toString();    
    }else if(intv <= 99){    
      res =  "0."+ ( intv).toString();   
    }else {
      res = intv.toString();

      res = res.substring(0,res.length-2) + "." + res.substring(res.length-2) 
    }
    return prefix+res;

  },
  toDir(str) {
      this.$router.push({
        name: str /*, 
        params: {
          dateStr: date,
          state: state,
          posid: 0
        }*/
      });
    },
  letsDeposit() {
    console.log("letsDeposit")

    if((this.depositAmount <= 0) || (this.depositAmount  > this.balanceDataLD.points)) {
      alert("提现数量要大于0并且小于" + this.balanceDataLD.points)
      return
    }

    let paras = {};

    paras.partnerId = this.partnerid;
    paras.withdrawMoney = this.depositAmount;

    let that = this;
    axios.get('customer/omc/withdrawPartner?partnerId='+this.partnerid + "&withdrawMoney="+this.depositAmount)
    .then(function (response) {
      console.log(response);
      if(response.data.retcode == 0){
        that.applyComplete = true;
        that.getMyWithDrawRecord();
      }else{
        
        alert(response.data.retmsg)
      }
      

    })
    .catch(function (error) {
      console.log(error);
    });  
  }
 }
}
</script>


// WEBPACK FOOTER //
// src/views/ld_deposit.vue